import React from 'react';
import PricingHelper from '../../helpers/PricingHelper';
import * as Roles from '../../resources/UserRole';
import Notifications from '../../services/Notifications';
import Price from './Price';
import { Link } from 'react-router-dom';
import Loading from '../Loading';
import Availability from './Availability';
import MessageWarning from '../MessageWarning';
import Authorize from '../Authorize';
import Api from '../../services/Api';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { withProductConfig } from '../../hooks/ProductConfigContext';
import { withStorefrontConfig } from '../../hooks/StorefrontSettingsContext';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import UserService from '../../services/UserService';
export class ProductSearchResultItem extends React.Component {
    constructor(props) {
        super(props);  
        
        this.state = {
            price: null,
            availability: null,
            fetchingPrice: false,
            quantity: 1,
            updateButtonIsVisible: false,
            addOrderButtonIsVisible: true,
            redraw: props.redraw,
            branchStockingType: null,
            favoriteFlag: this.props.favoriteProducts.some(x => x.productId === this.props.product.id)
        }
    }

    handleAddToCart = () => {
        const localized = this.props.productConfig.labels;
        if (this.state.fetchingPrice === false)
            return this.addToCart(localized);
        Notifications.error(localized.FetchingPriceMessage);
    }

    addToCart = async (localized) => {
        this.setState({ addOrderButtonIsVisible: false });
        if (!this.state.price) {
            await this.updateQtyAsync(); // Wait for pricing update
        }
        const { availability, price, quantity } = this.state;
        if (availability === "Unavailable" || availability === "Unknown") {
            this.setState({ addOrderButtonIsVisible: true });
            return Notifications.error(localized?.UnavailableMessage);
        }
        if (
            this.props.productConfig.settings.IsSeparatePriceAvailability === true ||
            price?.amount === 0
        ) {
            this.setState({ addOrderButtonIsVisible: true });
            return Notifications.error(localized?.PriceNotReady);
        }
        const product = {
            product: this.props.product,
            quantity,
            netPrice: price
        };
        this.props.AddItemToCart(product, localized);
        this.setState({ addOrderButtonIsVisible: true });
    };

    updateQtyAsync = () => {
        return new Promise((resolve) => {
            this.setState({ addOrderButtonIsVisible: false }, () => {
                const originalLoadPricing = this.loadPricing;

                this.loadPricing = (data) => {
                    originalLoadPricing.call(this, data);
                    resolve();
                    this.loadPricing = originalLoadPricing;
                };
                this.fetchPricing();
            });
        });
    };
    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleQtyBlur = (e) => {
        if (this.nodeQuantity && this.nodeQuantity.contains(e.target))
            return;
        if (this.state.quantity === "")
            this.setState({ quantity: 1 });
        this.setState({ quantity: this.state.quantity, updateButtonIsVisible: false });
    }

    handleQtyOnFocus = (e) => {
        this.setState({ updateButtonIsVisible: true });
    }

    handleQtyChange = (e) => {
        this.setState({ updateButtonIsVisible: true });
        if (e.target.value === "") {
            this.setState({ quantity: e.target.value });
        }
        else if (isPositiveNumber(e.target.value)) {
            this.setState({ quantity: parseInt(e.target.value) });
        }
    }

    handleQtyKeyUp = (e) => {
        if (e.keyCode === 13)
            this.handleQtyUpdateClick();
    }

    handleQtyUpdateClick = () => {
        this.setState({ updateButtonIsVisible: false });
        this.fetchPricing();
    }

    loadPricing = (data) => {
        if (data) {
            this.setState({
                price: data && this.props.currentUser.roles.includes(Roles.VIEW_NET_PRICE) ? { amount: data.price, currency: data.currency } : this.props.product.listPrice,
                fetchingPrice: false,
                availability: data.availability,
                branchStockingType: data.branchStockingType
            });
        }
    }

    fetchPricing = () => {
        if (this.props.selectedCustomer && this.props.selectedCustomer.billingType !== "1" && !PricingHelper.isItemConfigured(this.props.product) && !PricingHelper.isItemObsolete(this.props.product)) {
            this.setState({ fetchingPrice: true }, () => {
                const priceAvailRequest = this.getPriceAvailabilityRequest();
                Api.fetch(`/api/products/GetPriceAndAvailability`, { method: 'POST', body: JSON.stringify(priceAvailRequest) }, false).then(this.handleResponse).then(this.loadPricing)

            });
        }
        else {
            this.setState({ fetchingPrice: false });
        }
    }

    handleResponse(res) {
        if (res)
            return res.json();
    }

    getPriceAvailabilityRequest = () => {
        return {
            customerId: this.props.selectedCustomer.externalId,
            storefront: this.props.currentUser.storefrontNumber,
            storefrontId: this.props.StorefrontConfig.storefront.id,
            company: this.props.selectedCustomer.companyCode,
            sku: this.props.product.sku,
            transactionQuantity: this.state.quantity?.toString() || "1",
            implementationId: this.props.StorefrontConfig.storefront.implementationId,
            isSeparatePriceAvailability: this.props.productConfig.settings.IsSeparatePriceAvailability
        };
    }
    handleAddToFavorite = async (mode) => {
        const localized = this.props.productConfig.labels;
        if (mode) {
            const addFavResponse = await UserService.addUserFavorite(this.props.currentUser.id, this.props.product.id);
            if (addFavResponse) {
                this.setState({ favoriteFlag: addFavResponse });
                Notifications.message(localized.CreateFavorite);
            } else {
                Notifications.message(localized.FavoriteError);
            }

        } else {
            const removedFavResponse = await UserService.removeUserFavorite(this.props.product.id);
            if (removedFavResponse) {
                this.setState({ favoriteFlag: false });
                Notifications.message(localized.DeleteFavorite);
            }
            else { Notifications.message(localized.FavoriteError); }
        }
    }
    render() {
        const { product, selectedCustomer, hideListPrice, checkPriceAvailability } = this.props;
        const isConfiguredProduct = PricingHelper.isItemConfigured(product);
        const isObsoleteProduct = PricingHelper.isItemObsolete(product);
        const maxLines = 100;
        const localized = this.props.productConfig.labels;
        return (
            <div className="fele-product-details">
                <div className="grid">
                    <div className="flex-row">
                        <div className="product-image">
                            {
                                product.imageUrl &&
                                <div className="content">
                                    <img alt={product.sku} className="img-fluid" src={`${product.imageUrl}100x75px@1x/${product.sku}.jpg?q=80&x.template=y&crop=false`} />
                                </div>
                            }
                        </div>
                        <div className="favorite">
                            <Tooltip title={this.state.favoriteFlag ? <h1 style={{ fontSize: "15px" }}>{localized.RemoveFavorites}</h1>
                                : <h1 style={{ fontSize: "15px" }}>{localized.AddFavorites}</h1>} placement="top">
                                <Button onClick={() => this.handleAddToFavorite(!this.state.favoriteFlag)}>
                                    {this.state.favoriteFlag ? <FavoriteRoundedIcon sx={{ fontSize: 25, color: 'red' }} color="secondary" />
                                        : <FavoriteBorderRoundedIcon sx={{ fontSize: 25, color: 'black' }} color="secondary" />}
                                </Button>
                            </Tooltip>
                        </div>
                        <div className="part-name">
                            <div className="label">{localized.Description_Label}</div>
                            <div className="content">
                                {product.description}</div>
                        </div>
                        <div className="sku" >
                            <div className="label">{localized.Item_Label}</div>
                            <div className="content"><Link to={{ pathname: `/product/${encodeURIComponent(product.itemNumberShort)}`, state: { selectedCustomer: selectedCustomer } }}>{product.sku}</Link></div>
                        </div>
                        {
                            product.listPrice && !!hideListPrice &&
                            <div className="list-price">
                                <div className="label">{localized.ListPriceLabel}</div>
                                <div className="content"> <Price price={product.listPrice} country={selectedCustomer.address.country} /></div>
                            </div>
                        }
                        <div className="cost" >
                            {
                                checkPriceAvailability &&
                                !isConfiguredProduct &&
                                !isObsoleteProduct &&
                                <div>
                                    {
                                        !this.state.fetchingPrice && !this.state.price && !this.state.availability &&
                                        <div className="button-wrapper">
                                            <button className="button button-alt" onClick={this.handleQtyUpdateClick}>{localized.AvailabilityCost_ButtonText}</button>
                                        </div>
                                    }
                                    {this.state.fetchingPrice && <Loading />}

                                    {
                                        !this.state.fetchingPrice && this.state.price && this.state.availability &&
                                        <React.Fragment>
                                            <div className="label">{localized.YourCostLabel}</div>
                                            <Availability availability={this.state.availability} asIcon={false} />
                                            <Price price={this.state.price} country={selectedCustomer.address.country} />
                                        </React.Fragment>
                                    }
                                </div>
                            }
                        </div>
                        {
                            checkPriceAvailability &&
                            product.landedCostRule !== "NEW" &&
                            !isConfiguredProduct &&
                            !isObsoleteProduct &&
                            <div className="availability">
                                <div className="label">{localized.AvailabilityLabel}:</div>
                                {
                                    this.state.fetchingPrice &&
                                    <div className="pill">
                                        <Loading />
                                    </div>
                                }
                                {
                                    !this.state.fetchingPrice &&
                                    <Availability availability={this.state.availability} />
                                }
                            </div>
                        }
                        {
                            product && (isConfiguredProduct || isObsoleteProduct) &&
                            <div className="availability">
                                {
                                    isConfiguredProduct &&
                                    <MessageWarning title={localized.ConfiguredItemWarningTitle} message={localized.ConfiguredItemWarning} />
                                }
                                {
                                    isObsoleteProduct &&
                                        <MessageWarning title={localized.ObsoleteItem || 'Obsolete Item'} message={localized.ObsoleteItemsNotAvailable || 'Obsolete items are not available for purchase'} />
                                }
                            </div>
                        }
                        <div className="add-to-cart">
                            {
                                checkPriceAvailability &&
                                product.landedCostRule !== "NEW" &&
                                !isConfiguredProduct &&
                                !isObsoleteProduct &&
                                <Authorize hasRoles={[Roles.DEVELOPER, Roles.PLACE_ORDERS, Roles.PLACE_QUOTES]} displayMessage={false}>

                                    <div className="flex">
                                        <div className="input-wrapper quantity" ref={node => (this.nodeQuantity = node)}>
                                            <input
                                                type="text"
                                                name="quantity"
                                                value={this.state.quantity}
                                                onChange={this.handleQtyChange}
                                                onBlur={this.handleQtyBlur}
                                                onFocus={this.handleQtyOnFocus}
                                                onKeyUp={this.handleQtyKeyUp}
                                                autoComplete="off" />
                                            {
                                                this.state.updateButtonIsVisible &&
                                                <div className="update button-wrapper small">
                                                    <button className="button button-alt" onClick={this.handleQtyUpdateClick} >{localized.ButtonText_CheckAvailability}</button>
                                                </div>
                                            }
                                        </div>
                                        <Authorize hasRoles={[Roles.PLACE_ORDERS]} displayMessage={false}>
                                            <div className="button-wrapper add-to-order">
                                                {
                                                    this.props.cartLines.length < maxLines && this.state.addOrderButtonIsVisible &&
                                                    <button className="button" onClick={this.handleAddToCart}>{localized.ButtonText_AddToOrder}</button>
                                                }
                                                {
                                                    !this.state.addOrderButtonIsVisible &&
                                                    <div className="pill">
                                                        <Loading />
                                                    </div>
                                                }
                                                {
                                                    this.props.cartLines.length >= maxLines &&
                                                    <FontAwesomeIcon icon={faExclamationTriangle} color="orange" title={localized.CartMaxLines} />
                                                }
                                            </div>
                                        </Authorize>
                                    </div>
                                </Authorize>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function isPositiveNumber(value) {
    let exp = new RegExp(/^[1-9]\d*$/)
    return exp.test(value);
}

ProductSearchResultItem.propTypes = {
    product: PropTypes.object,
    selectedCustomer: PropTypes.object,
    currentUser: PropTypes.object,
    hideListPrice: PropTypes.bool,
    checkPriceAvailability: PropTypes.bool
}

export default (withStorefrontConfig(withProductConfig(ProductSearchResultItem)))